import React, { useEffect } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { resetUnreadChatMsgCount, setInComingChatBubbleMsg, setIsChatBubbleOpen } from "../../reducers/chat-reducer";
import { setIsChatDrawerOpen } from "../../reducers/common-reducer";

const IncomingChatBubble = ({ isForMobile = false }) => {
    const dispatch = useDispatch();
    const { isChatBubbleOpen, inComingChatBubbleMsg } = useSelector((state) => state.chatReducer);

    const handleClickOnChatBubble = () => {
        dispatch(setInComingChatBubbleMsg({}));
        dispatch(setIsChatBubbleOpen(false));
        dispatch(setIsChatDrawerOpen(true));
        dispatch(resetUnreadChatMsgCount());
    };

    /* Handle active class based on incoming notification */
    useEffect(() => {
        if (isChatBubbleOpen) {
            document.getElementById("mob-chat-incomming-msg")?.classList.add("active");
        } else {
            document.getElementById("mob-chat-incomming-msg")?.classList.remove("active");
        }
    }, [isChatBubbleOpen]);

    return (
        <>
            {isForMobile ? (
                <div
                    className='chat-incomming-msg mob-chat-incomming-msg'
                    onClick={handleClickOnChatBubble}
                    onKeyDown={() => {}}
                    id='mob-chat-incomming-msg'
                >
                    <div className='chat-incomming-msg-box'>
                        <div className='chat-participant-name'>{inComingChatBubbleMsg.participantName}</div>
                        <div className='chat-participant-msg'>{inComingChatBubbleMsg.msg}</div>
                    </div>
                </div>
            ) : (
                <div className={clsx("chat-incomming-msg", isChatBubbleOpen && "active")} onClick={handleClickOnChatBubble} onKeyDown={() => {}}>
                    <div className='chat-incomming-msg-box'>
                        <div className='chat-participant-name'>{inComingChatBubbleMsg.participantName}</div>
                        <div className='chat-participant-msg'>{inComingChatBubbleMsg.msg}</div>
                    </div>
                </div>
            )}
        </>
    );
};

IncomingChatBubble.propTypes = {
    isForMobile: PropTypes.bool,
};

export default IncomingChatBubble;
